import { Component, ViewChild, EventEmitter, Output } from '@angular/core';
import { DispatchesService } from '../../shared/services/dispatches.service';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';
import { SelectEvent } from '@progress/kendo-angular-layout';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { AdditionalDispatchData } from '../../shared/models/AdditionalDispatchData';
import { DispatchBus } from '../../shared/models/DispatchBus';
import { DispatchPage } from '../../shared/models/DispatchPage';
import { DispatchSummary } from '../../shared/models/DispatchSummary';
import { DQOIService } from '../../shared/services/DQOI.service';
import { SearchTarget } from '../../shared/enums/SearchTarget';
import { BaseDQOIComponent } from '../../shared/base-components/base-dqoi.component';
import { GlobalsService } from '../../shared/services/globals.service';
import { DQOIReferenceDataQuery } from '../../dqoi/state/dqoi-reference-data.query';
import { GItem } from '../../shared/models/GItem';
import { CommonFunctions } from '../../shared/static/common-functions';
import { DQOIState } from '../../shared/models/DQOIState';
import { DateFunctions } from '../../shared/static/date-functions';
import { MessageType } from '../../shared/enums/MessageType';
import { DispatchMessageInfo } from '../../shared/models/DispatchMessageInfo';
import { DQOIItem } from '../../shared/models/DQOIItem';
import { CommonValues } from '../../shared/static/CommonValues';
import { Message } from '../../shared/models/message';
import { BaseMessageInfo } from '../../shared/models/BaseMessageInfo';
import { Email } from '../../shared/models/Email';
import { CommonParam } from '../../shared/models/CommonParam';
import { DispatchNotesComponent } from '../dispatch-notes/dispatch-notes.component';
import { DispatchAssignmentsComponent } from '../assignments/dispatch-assignments.component';
import { DispatchEquipSvcdComponent } from '../equipment/serviced/dispatch-equip-svcd.component';
import { DispatchPartsRequestedComponent } from '../parts/requested/dispatch-parts-requested.component';
import { DispatchCustomerSuppliedPartsComponent } from '../parts/customer-supplied/dispatch-customer-supplied-parts.component';
import { DispatchLaborComponent } from '../labor/dispatch-labor.component';
import { DispatchErrorsComponent } from '../errors/dispatch-errors.component';
import { WorkOrderAttachmentsComponent } from '../attachments/workorder-attachments.component';
import { SaveMode } from '../../shared/enums/SaveMode';
import { DispatchSaveParam } from '../../shared/models/DispatchSaveParam';
import { ChangeStatusDialogComponent } from '../change-status/change-status-dialog.component';
import { WindowContents } from '../../shared/enums/windowContents';
import { DispatchItemBus } from '../../shared/models/DispatchItemBus';
import { DbTable } from '../../shared/enums/DbTable';
import { ScheduleDispatchesComponent } from '../scheduled/schedule-dispatches.component';
import { v_LocationDetailBus } from '../../shared/models/v_LocationDetailBus';
import { DisplayNotesComponent } from '../../shared/components/display-notes/display-notes.component';
import { DispatchThirdPartyHistoryDialogComponent } from '../dispatch-third-party-history-dialog/dispatch-third-party-history-dialog.component';
import { InvoiceEstimateDialogComponent } from '../../invoices/invoice-estimate/invoice-estimate-dialog.component';
import { CRUDActions } from '../../shared/enums/CRUDActions';
import { ConfirmOutput } from '../../shared/models/ConfirmOutput';
import { CPDialogResult } from '../../shared/enums/CPDialogResult';
import { DispatchKudosComponent } from '../kudos/dispatch-kudos.component';
import { Input } from '@angular/core';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { PrintService } from '@app/cp/shared/services/print.service';
import { ICPLoader, UseCPLoader } from '@app/cp/shared/decorators/cploader/cploader-decorator';

@UseCPLoader()
@Component({
    selector: 'invoice-picker',
    templateUrl: './invoice-picker.component.html',
    styleUrls: ['./invoice-picker.component.scss'],
    standalone: false
})
export class InvoicePickerComponent extends BaseDQOIComponent<DispatchBus, DispatchesService, AdditionalDispatchData, DispatchPage>  {
    appCode: string = "DispatchIp";
    compLoader: ICPLoader = this as any;
    constructor(globals: GlobalsService, featureFlagService: FeatureFlagService, svc_dqoi: DQOIService, svc_data: DispatchesService, qry_rd: DQOIReferenceDataQuery, private printService: PrintService) {
        super(globals, featureFlagService, svc_dqoi, qry_rd);
        this.svc_data = svc_data;
        this.addtlDataClass = "AdditionalDispatchData";
        this.pageData = new DispatchPage(svc_data);
        this.searchTarget = SearchTarget.dispatch;
        this.saveMode = SaveMode.all;
    }
    @ViewChild("Notes") notesComp: DispatchNotesComponent;
    @ViewChild("CollNotes") collNotesComp: DisplayNotesComponent;
    @ViewChild("InjuryNotes") injuryNotesComp: DispatchNotesComponent;
    @ViewChild("Assignments") assignmentsComp: DispatchAssignmentsComponent;
    @ViewChild("Attachments") attachmentsComp: WorkOrderAttachmentsComponent;
    @ViewChild("Equipment") equipSvcdComp: DispatchEquipSvcdComponent;
    @ViewChild("PartsReq") partsRequestedComp: DispatchPartsRequestedComponent;
    @ViewChild("CustParts") customerSuppliedPartsComp: DispatchCustomerSuppliedPartsComponent;
    @ViewChild("Labor") laborComp: DispatchLaborComponent;
    @ViewChild("ErrorsComp") errorsComp: DispatchErrorsComponent;
    @ViewChild("Kudos") kudosComp: DispatchKudosComponent;
    @ViewChild("ChangeStatus") changeStatusComp: ChangeStatusDialogComponent;
    @ViewChild("ScheduleDispatches") scheduleDispatchesComponent: ScheduleDispatchesComponent;
    @ViewChild('dispatchThirdPartyHistoryDialog') public dispatchThirdPartyHistoryDialog: DispatchThirdPartyHistoryDialogComponent;
    @ViewChild('invoiceEstimateDialog') public invoiceEstimateDialog: InvoiceEstimateDialogComponent;
    @Output() dropEvent: EventEmitter<any> = new EventEmitter<any>();
    @Output() closeEvent: EventEmitter<any> = new EventEmitter<any>();

    _viewOnly: boolean = false;
    @Input() set viewOnly(value: boolean) {
        this._viewOnly = value;
        this.canDragChildren = !this._viewOnly;
    }
    get viewOnly(): boolean {
        return this._viewOnly;
    }
    canDragChildren: boolean = !this._viewOnly;
    get saveMode_Notes(): any {
        let saveMode = this.saveMode;
        if (this.hasReferenceData) {
            if (this.serviceMode === "1") {
                saveMode = SaveMode.individual;
            }
        }
        return saveMode;
    }
    get saveMode_Attachments() : any {
        let saveMode = this.saveMode;
        if (this.hasReferenceData) {
            if (this.referenceData.serviceMode === "1" && this.rights.FG2RegularAccess != true) {
                saveMode = SaveMode.individual;
            }
        }
        return saveMode;
    }
    get readOnly_ServiceMode(): boolean {
        return this.serviceMode === "1" ? false : this.readOnly;
    }
    get canEditChild_Notes(): boolean {
        return this.customFormValidation() && ((this.saveMode == SaveMode.individual || !this.readOnly) && ((this.canSave && this.saveMode === SaveMode.all) || this.hasId));
    }
    get canEditChild_Attachments(): boolean {
        return this.customFormValidation() && ((this.saveMode == SaveMode.individual || !this.readOnly) && (this.canSave || this.hasId));
    }
    get isDirty(): boolean {
        return !this.readOnly_ServiceMode && this.hasEditForm && this.editForm.dirty;
    }
    get originalStatusId(): any {
        return this.hasData ? this.data.dispatchStatusId : null;
    }
    get hasOriginalStatusId(): any {
        return this.originalStatusId !== null;
    }
    get customAppSaveValidation(): boolean {
        return this.serviceMode === "0" || this.statusId !== this.originalStatusId ? true : false;
    }
    viewHistory() {

        this.dispatchThirdPartyHistoryDialog.openHistory(this.id);

    }
    viewInvoiceEstimate() {

        this.invoiceEstimateDialog.show(this.id, SearchTarget.dispatch);

    }

    subs_dataScheduledDispatches: Subscription;
    public editForm: UntypedFormGroup = new UntypedFormGroup({
        'dispatchId': new UntypedFormControl(),
        'dispatchNumber': new UntypedFormControl(),
        'companyId': new UntypedFormControl(),
        'customerId': new UntypedFormControl(null, Validators.required),
        'locationId': new UntypedFormControl(null, Validators.required),
        'dispatchStatusId': new UntypedFormControl(null, Validators.required),
        'priorityId': new UntypedFormControl(),
        'notToExceed': new UntypedFormControl(),
        'ponumber': new UntypedFormControl(),
        'wonumber': new UntypedFormControl(),
        'quoteNumber': new UntypedFormControl(),
        'invoiceNumber': new UntypedFormControl(),
        'foremanId': new UntypedFormControl(),
        'jobClassificationId': new UntypedFormControl(),
        'dispatchClassificationId': new UntypedFormControl(),
        'dispatchRepairCatId': new UntypedFormControl(),
        'dispatchProblemCodeId': new UntypedFormControl(),
        'dispatchActionCodesId': new UntypedFormControl(),
        'dispatchSummaryCodeId': new UntypedFormControl(),
        'dispatchCauseCodesId': new UntypedFormControl(),
        'dispatchFailureCodesId': new UntypedFormControl(),
        'receivedDateTime': new UntypedFormControl(null, Validators.required),
        'receivedById': new UntypedFormControl(null, Validators.required),
        'estimatedBeginDate': new UntypedFormControl(),
        'estimatedEndDate': new UntypedFormControl(),
        'estimatedCost': new UntypedFormControl(),
        'isConstruction': new UntypedFormControl(false),
        'isProgressBill': new UntypedFormControl(false),
        'contractPrice': new UntypedFormControl(null as number),
        'profit1': new UntypedFormControl(null as number),
        'profit2': new UntypedFormControl(null as number),
        'dispatchReason': new UntypedFormControl(),
        'accountClassId': new UntypedFormControl(null, Validators.required),
        'acctMgr': new UntypedFormControl(),
        'whoCalledName': new UntypedFormControl(),
        'refTrackNbr': new UntypedFormControl(),
        'callbackId': new UntypedFormControl(),
        'callbackNumber': new UntypedFormControl(),
        'insertDt': new UntypedFormControl(),
        'insertUserId': new UntypedFormControl(),
        'updateDt': new UntypedFormControl(),
        'updateUserId': new UntypedFormControl()
        ////    'FirstName': new FormControl('', [Validators.required, Validators.maxLength(10)]),// InitCodeValidators.isNotDuplicate]),
        //'firstName': new FormControl('', [Validators.required, Validators.maxLength(50)]),
        //'middleName': new FormControl('', Validators.maxLength(50)),
    });
    setForm() {
        this.editForm.patchValue({
            dispatchId: this.data.dispatchId,
            dispatchNumber: this.data.dispatchNumber,
            companyId: this.data.companyId,
            customerId: this.data.customerId,
            locationId: this.data.locationId,
            dispatchStatusId: this.data.dispatchStatusId,
            priorityId: this.data.priorityId,
            notToExceed: this.data.notToExceed,
            ponumber: this.data.ponumber,
            wonumber: this.data.wonumber,
            foremanId: this.data.foremanId,
            jobClassificationId: this.data.jobClassificationId,
            dispatchClassificationId: null,
            dispatchRepairCatId: this.data.dispatchRepairCatId,
            dispatchProblemCodeId: this.data.dispatchProblemCodeId,
            dispatchActionCodesId: this.data.dispatchActionCodesId,
            dispatchSummaryCodeId: this.data.dispatchSummaryCodeId,
            dispatchCauseCodesId: this.data.dispatchCauseCodesId,
            dispatchFailureCodesId: this.data.dispatchFailureCodesId,
            receivedDateTime: this.data.receivedDateTime,
            receivedById: this.data.receivedById,
            estimatedBeginDate: this.data.estimatedBeginDate,
            estimatedEndDate: this.data.estimatedEndDate,
            estimatedCost: this.data.estimatedCost,
            isConstruction: this.data.isConstruction,
            isProgressBill: this.data.isProgressBill,
            contractPrice: this.data.contractPrice,
            dispatchReason: this.data.dispatchReason,
            accountClassId: this.data.accountClassId,
            whoCalledName: this.data.whoCalledName,
            refTrackNbr: this.data.refTrackNbr,
            callbackId: this.data.callbackId,
            insertDt: this.data.insertDt,
            insertUserId: this.data.insertUserId,
            updateDt: this.data.updateDt,
            updateUserId: this.data.updateUserid
        });
    }
    setFormAddtl() {
        this.editForm.patchValue({
            quoteNumber: this.addtlData.quoteNumber,
            invoiceNumber: this.addtlData.invoiceNumber,
            profit1: this.addtlData.profit1,
            profit2: this.addtlData.profit2,
            acctMgr: this.addtlData.acctMgr,
            callbackNumber: this.addtlData.callbackNumber
        });

    }
    setFormLocation(data: v_LocationDetailBus) {
        if (!this.hasId) {
            this.editForm.patchValue({
                notToExceed: data.nte
            });
        }
    }
    dispatchHistoryDaysBack: number = 60;
    get hasAccountClass(): boolean {
        return this.hasEditForm && CommonFunctions.hasValue(this.editForm.value.accountClassId);
    }
    get hasStatus(): boolean {
        return this.hasEditForm && CommonFunctions.hasValue(this.editForm.value.dispatchStatusId);
    }
    get hasRcvdDate(): boolean {
        return this.hasEditForm && CommonFunctions.hasValue(this.editForm.value.receivedDateTime);
    }
    get hasRcvdPerson(): boolean {
        return this.hasEditForm && CommonFunctions.hasValue(this.editForm.value.receivedById);
    }
    get statusId(): any {
        return this.hasStatus ? this.editForm.value.dispatchStatusId : null;
    }
    get canAssignTech(): boolean {
        let can: boolean = (this.hasId || this.canSave) && this.serviceMode !== '1';
        return can;
    }
    get canScheduleDispatches(): boolean {
        return this.serviceMode !== '1';
    }
    get canEmail(): boolean {
        return this.serviceMode !== '1';
    }
    get canPrint(): boolean {
        return this.hasId;
    }
    customFormValidation() {
        return super.customFormValidation();
            //&& this.hasAccountClass
            //&& this.hasStatus
            //&& this.hasRcvdDate
            //&& this.hasRcvdPerson;
    }
    //public cpActiveChildComp: number;
    //public cpWindowData: any;
    //public cpShowWindow: boolean = false;
    //public cpContentTypes = WindowContents;
    //cpPopWindow(injected: any) {
    //    this.cpActiveChildComp = injected.contentType;
    //    this.cpWindowData = injected.boardData;
    //    this.cpShowWindow = true;
    //}
    onCPWindowClosed(e) {
        this.refreshData(DbTable.DispatchAssignments);
        super.onCPWindowClosed(e);
    }

    parentdropEvent(e) {
        this.dropEvent.emit(e);
    }
    assignTech(personToAssignId: any = null) {
        let dataObj: DispatchItemBus = new DispatchItemBus();
        dataObj.dispatchId = this.data.dispatchId;
        dataObj.dispatchNumber = this.data.dispatchNumber;
        dataObj.locationId = this.data.locationId;
        dataObj.customerId = this.data.customerId;
        dataObj.personToAssignId = personToAssignId;
        dataObj.from = SearchTarget.dispatch;
        if (!this.hasId) {
            this.setAfterSaveMessage({ messageType: MessageType.assignNewTech, value: personToAssignId, values: personToAssignId, messageSubject: null, message: null, dqoiIndex: null, searchTarget: SearchTarget.any, refreshTarget: null });
            this.save();
        }
        else {
            this.cpPopWindow({ contentType: WindowContents.assignTech, boardData: { assignDispatch: dataObj } });
        }
    }
    origGridData: DispatchSummary[] = new Array();
    gridData: DispatchSummary[];
    get emailTitle(): string {
        return this.hasId && this.customerId === CommonValues.Customer_WalMart ? 'WalMart Email' : 'Email';
    }
    email() {
        if (this.customerId === CommonValues.Customer_WalMart) {
            this.svc_data.getWalMartEmail(this.id).subscribe((info: BaseMessageInfo) => {
                if (!info.saveError) {
                    let email: Email = new Email(info.primaryReturn);
                    window.location.assign("mailto: ?subject=" + email.subjectEncoded() + "&body=" + email.bodyEncoded());
                }
                else {
                    this.saveError("Error Trying to Construct Email: " + info.message);
                }
            });
        }
        else {
            this.svc_data.getEmailDefaultsForDispatch(this.id).subscribe((info: BaseMessageInfo) => {
                if (!info.saveError) {
                    let email: Email = new Email(info.primaryReturn);
                    window.location.assign("mailto: ?subject=" + email.subjectEncoded() + "&body=" + email.bodyEncoded());
                }
                else {
                    this.saveError("Error Trying to Construct Email: " + info.message);
                }
            });
        }
    }
    //  companyId: string = "C12D7F16-E1C9-4689-9F44-89C5CA29AFE2";

    createNew(busObj: DispatchBus) {
        return new DispatchBus(busObj);
    }

    public setId(id: String) {
        this.id = id;
        this.getData();
    }
    getData() {
        super.getData();
        CommonFunctions.unsubscribe(this.subs_data);
        this.subs_data = this.svc_data.get(this.id).subscribe(data => {
            if (!data) {
                console.error("Unable to find resource with id", this.id);
                return; // no sense moving on errors will happen in setData
            }
            this.setData(data);
            this.getDetailData();
        });

    }

    getDetailData() {
        CommonFunctions.unsubscribe(this.subs_dataAddInfo);
        this.subs_dataAddInfo = this.svc_data.GetAdditionalDispatchData(this.id).subscribe(data => {
            this.addtlData = new AdditionalDispatchData(data);
            this.setFormAddtl();
            if (this.data && this.data.dispatchId) {
                this.pageData.getLabor(this.data.dispatchId);
                this.pageData.getPartsRequested(this.data.dispatchId);
                this.pageData.getPartsOrderedAll(this.data.dispatchId);
                this.pageData.getParts(this.data.dispatchId, this.referenceData);
                this.pageData.getCustParts(this.data.dispatchId);
            }
        });
    }
    setData(data: DispatchBus) {
        this.customerChanged(data.customerId);
        this.locationChanged(data.locationId);
        super.setData(data);
        if (CommonFunctions.hasValue(this.afterSaveMessage)) {
            let msg = _.cloneDeep(this.afterSaveMessage);

            this.setAfterSaveMessage(null);
            this.parentMessage(msg, this.compLoader);
        }
    }
    scheduleDispatchesActive: boolean = false;
    scheduleDispatchesClosed(e: any) {
        this.scheduleDispatchesActive = false;
    }
    scheduleDispatches() {
        this.scheduleDispatchesComponent.setup(null);
        this.scheduleDispatchesActive = true;
    }

    override customParentMessage(e: Message) {

        if (e.messageType === MessageType.assignNewTech) {
            this.assignTech(null);
        }
        else if (e.messageType === MessageType.reassignTech) {
            this.assignTech(e.values);
        }
    }
    refreshData(refreshTarget: DbTable) {
        if (!CommonFunctions.hasValue(refreshTarget)) {
            super.refreshData(null);
        }
        switch (refreshTarget) {
            case DbTable.DispatchAssignments:
                this.pageData.getAssignments(this.data.dispatchId, this.referenceData);
                break;
        }
    }
    //Save Dispatch according to that setting which is a 1lockdown setting
    saveServiceMode1() {
        if (this.hasStatus && this.statusId !== this.data.dispatchStatusId) {
            let param: CommonParam = new CommonParam();
            param.addParam("dispatchId", this.id);
            param.addParam("newStatusId", this.statusId);
            this.svc_data.changeDispatchStatus(param).subscribe((info: BaseMessageInfo) => {
                if (!info.saveError) {
                    this.saveSuccess();
                }
                else {
                    this.saveError(info.message);
                }
            });
        }
    }
    saveAll() {
        if (this.serviceMode === "1") {
            this.saveServiceMode1();
        }
        else {
            let now: Date = DateFunctions.getDateNow();
            let busObj: DispatchSaveParam = new DispatchSaveParam(this.data);
            busObj.setFromForm(this.editForm.value);
            //busObj.billingGeographyInfo = this.billToGeoInfoComp.getData();
            //busObj.shippingGeographyInfo = this.locGeoInfoComp.getData();
            busObj.setCommon(this.globals.userId, now, this.globals.companyId);
            busObj.setBeforeSave();
            // busObj.copyData(this.addtlData, this.pageData);
            if (CommonFunctions.hasValue(this.notesComp)) {
                busObj.notes = _.cloneDeep(this.notesComp.getChanged());
                busObj.addDeletedItems(this.notesComp.getDeletedItems());
            }
            if (CommonFunctions.hasValue(this.injuryNotesComp)) {
                busObj.injuryNotes = _.cloneDeep(this.injuryNotesComp.getChanged());
                busObj.addDeletedItems(this.injuryNotesComp.getDeletedItems());
            }
            if (CommonFunctions.hasValue(this.assignmentsComp)) {
                busObj.assignments = _.cloneDeep(this.assignmentsComp.getChanged());
                busObj.addDeletedItems(this.assignmentsComp.getDeletedItems());
            }
            if (CommonFunctions.hasValue(this.attachmentsComp)) {
                busObj.attachments = _.cloneDeep(this.attachmentsComp.getChanged());
                busObj.addDeletedItems(this.attachmentsComp.getDeletedItems());
            }
            if (CommonFunctions.hasValue(this.equipSvcdComp)) {
                busObj.equipment = _.cloneDeep(this.equipSvcdComp.getChanged());
                busObj.addDeletedItems(this.equipSvcdComp.getDeletedItems());
            }
            if (CommonFunctions.hasValue(this.partsRequestedComp)) {
                busObj.partsReq = _.cloneDeep(this.partsRequestedComp.getChanged());
                busObj.addDeletedItems(this.partsRequestedComp.getDeletedItems());
            }
            if (CommonFunctions.hasValue(this.customerSuppliedPartsComp)) {
                busObj.custParts = _.cloneDeep(this.customerSuppliedPartsComp.getChanged());
                busObj.addDeletedItems(this.customerSuppliedPartsComp.getDeletedItems());
            }
            if (CommonFunctions.hasValue(this.laborComp)) {
                busObj.labor = _.cloneDeep(this.laborComp.getChanged());
                busObj.addDeletedItems(this.laborComp.getDeletedItems());
            }
            if (CommonFunctions.hasValue(this.errorsComp)) {
                busObj.errors = _.cloneDeep(this.errorsComp.getChanged());
                busObj.addDeletedItems(this.errorsComp.getDeletedItems());
            }
            if (CommonFunctions.hasValue(this.kudosComp)) {
                busObj.kudos = _.cloneDeep(this.kudosComp.getChanged());
                busObj.addDeletedItems(this.kudosComp.getDeletedItems());
            }
            this.mainLoadingOn(true, this.compLoader);

            this.svc_data.saveAll(busObj).subscribe((info: DispatchMessageInfo) => {
                if (!info.saveError) {
                    //  let dataObj: InvoiceBus = new InvoiceBus(info.invoice);
                    this.clear();
                    this.getDataFromId(info.dispatch.dispatchId);
                    this.saveSuccess();
                    if (!busObj.hasId) {
                        this.setDQOIItem(info.dispatch.dispatchId);
                    }
                }
                else {
                    this.saveError(info.message);
                }
                this.mainLoadingOff(true, this.compLoader);
            });
        }
    }
    refreshDQOI() {
        let id: any = this.id;
        this.clear();
        this.getDataFromId(id);
    }
    protected resetData(dqoiItem: DQOIItem) {
        super.resetData(dqoiItem);
        if (dqoiItem.hasDispatchId) {
            this.id = dqoiItem.dispatchId;
            this.getData();
        }
    }
    setDQOIItem(id: any) {
        let item: DQOIItem = this.svc_dqoi.getDQOIItem(this.dqoiIndex);
        let busObj: DQOIItem = new DQOIItem(item);
        busObj.dispatchId = id;
        this.svc_dqoi.setDQOIItem(busObj);
    }
    setDQOIState() {
        let data: DQOIState = this.svc_dqoi.getDQOIState();

        data.dispatchId = this.data.dispatchId;
        if (!this.settingFromDQOIState) {
            data.customerId = this.data.customerId;
            data.invoiceId = this.data.invoiceId;
            data.quoteId = this.data.quoteId;
        }

        this.svc_dqoi.nextDQOIState(data);
        this.settingFromDQOIState = false;

        if (CommonFunctions.hasValue(this.dqoiIndex) && this.dqoiIndex > 0) {
            let item: DQOIItem = this.svc_dqoi.getDQOIItem(this.dqoiIndex);
            this.setCommon(item);
        }
    }
    protected setCommon(dqoiItem: DQOIItem) { }
    onTabSelect(e: SelectEvent) {
        if (e.title === 'Dispatch History') { //&& !this.pageData.hasHistory) {
            let date: Date = DateFunctions.getDateBackNDays(this.dispatchHistoryDaysBack);
            this.pageData.getHistory(this.locationId, date);
        }
        else if (e.title === 'Assignments' && !this.pageData.hasAssignments) {
            this.pageData.getAssignments(this.data.dispatchId, this.referenceData);
        }
        else if (e.title === 'Labor' && !this.pageData.hasLabor) {
            this.pageData.getLabor(this.data.dispatchId);
        }
        else if (e.title === 'Parts' && !this.pageData.hasPartsRequested) {
            this.pageData.getPartsRequested(this.data.dispatchId);
        }
        else if (e.title === 'Serviced Equipment' && !this.pageData.hasEquipmentSvcd) {
//            this.pageData.getEquipmentSvcd(this.data.dispatchId); //, 'SVCDEQUIP');
            this.pageData.getData(this.data.dispatchId, 'SVCDEQUIP');

            //this.pageData.getData(id, code);
        }
        else if (e.title === 'Status History' && !this.pageData.hasStatusHist) {
            this.pageData.getStatusHistory(this.data.dispatchId);
        }
        else if (e.title === 'Attachments' && !this.pageData.hasAttachments) {
            this.pageData.getDispatchAttachments(this.data.dispatchId);
        }
        else if (e.title === 'Photos' && !this.pageData.hasImages) {
            this.pageData.getImages(this.data.dispatchId);
        }
        else if (e.title === 'Kudos' && !this.pageData.hasDispatchKudos) {
            this.pageData.getDispatchKudos(this.data.dispatchId);
        }
        else if (e.title === 'Opportunity' && !this.pageData.hasErrors) {
            this.pageData.getErrors(this.data.dispatchId);
        }
        else if (e.title === 'Vendor Credits' && !this.pageData.hasVendorCredits) {
            this.pageData.getVendorCredits(this.data.dispatchId);
        }
        else if (e.title === 'Assets' && !this.pageData.hasAssets) {
            this.pageData.getAssets(this.data.dispatchId);
        }
        //else Status History
    }

    onPartsTabSelect(e: SelectEvent) {
        if (e.title === 'Requested' && !this.pageData.hasPartsRequested) {
            this.pageData.getPartsRequested(this.data.dispatchId);
        }
        else if (e.title === 'Ordered' && !this.pageData.hasPartsOrdered) {
            this.pageData.getPartsOrdered(this.data.dispatchId);
        }
        else if (e.title === 'Used' && !this.pageData.hasParts) {
            this.pageData.getParts(this.data.dispatchId, this.referenceData);
        }
        else if (e.title === 'Customer Supplied' && !this.pageData.hasCustParts) {
            this.pageData.getCustParts(this.data.dispatchId);
        }
    }
    createDraw() {

    }
    delete() {
        if (this.data.isAdded) {
            this.clear();
        }
        else {
            this.svc_data.deleteDispatch(this.id).subscribe((info: BaseMessageInfo) => {
                if (!info.saveError) {
                    this.deleteSuccess();
                    this.clear();
                }
                else {
                    this.deleteError(info.message)
                }
            });
        }
    }
    itemDisabled(itemArgs: { dataItem: any, index: any }) {
        return !itemArgs.dataItem.canSelect;
    }
    canEditLab() {
        return this.rights.EditLabor;
    }
    canEditContractPrice() {
        return this.rights.EditContractPrice;
    }
    get canDelete(): boolean {
        return (this.hasId || (this.hasData && this.data.isAdded)) && this.rights.DeleteDispatch && this.serviceMode !== "1";
    }
    refreshMessage(event: any) {
        this.pageData.getDispatchAttachments(this.id);

    }
    get canEdit(): boolean {
        let can: boolean = false;

        if ((this.hasId || (this.hasData && this.data.isAdded))) {
            if (this.canEditBilledOrClosed()) can = true;
            else if (this.canEditReadyForBillingConstruction()) can = true;
            else if (this.data.dispatchStatusId != CommonValues.Dispatch_Billed && this.data.dispatchStatusId != CommonValues.Dispatch_Closed &&
                this.data.dispatchStatusId != CommonValues.Dispatch_ReadyForBillingConstruction && this.rights.MaintainDispatches) {
                can = true;
            }
            can = can
        }

        return can;
    }
    canEditBilledOrClosed(): boolean {
        let can: boolean = false;
        if ((this.data.dispatchStatusId == CommonValues.Dispatch_Billed || this.data.dispatchStatusId == CommonValues.Dispatch_Closed) && this.rights.EditClosedDispatch) {
            can = true;
        }
        return can;
    }
    canEditReadyForBillingConstruction(): boolean {
        let can: boolean = false;
        if ((this.data.dispatchStatusId == CommonValues.Dispatch_ReadyForBillingConstruction) && this.rights.EditReadyForBillingConstruction) {
            can = true;
        }
        return can;
    }

    print() {
        this.compLoader.cpLoader = true;
        this.svc_data.print(this.id).subscribe(data => {
            this.printService.printPdf(data);
            this.compLoader.cpLoader = false;
        });
    }
    statusCBOChanged(item: GItem) {
        this.checkStatusChange(item.value, this.data.dispatchStatusId);
    }
    subs_statusChangeCheck: Subscription;
    checkStatusChange(newStatusId: any, existingStatusId: any) {
        let param: CommonParam = new CommonParam();
        param.addParam("newStatusId", newStatusId);
        param.addParam("existingStatusId", existingStatusId);
        param.addParam("dispatchId", this.id);
        CommonFunctions.unsubscribe(this.subs_statusChangeCheck);
        this.subs_statusChangeCheck = this.svc_data.checkDispatchStatusChange(param).subscribe((info: DispatchMessageInfo) => {
            if (info.statusChangeOk === false) {
                let title: string = "Status Change";
                this.miShow("Change Status Warning: " + (info.saveError ? "Error" : "Warning"), info, info, title, null, null);
                this.patchStatus(this.data.dispatchStatusId);
            }
        });
    }
    patchStatus(statusId: any) {
        this.editForm.patchValue({
            dispatchStatusId: statusId
        });

    }

    canEditRight(code: string) {
        return false;
    }
    canEditLabor() {
        return true;
    }
    callBackSearch: boolean = false;
    doCallBackSearch(code: string) {
        if (code === "CLEAR") {
            this.setCallback(null, null);
        }
        else {
            this.callBackSearch = true;
        }
    }
    setCallback(id: any, number: string) {
        this.editForm.patchValue({
            callbackId: id,
            callbackNumber: number
        });
        this.setDirty();
    }
    callBackSelected(value: any) {
        this.callBackSearch = false;
        if (value != null) {
            this.setCallback(value.DispatchId, value.DispatchNumber);
            //this.editForm.patchValue({
            //    callbackId: value.DispatchId,
            //    callbackNumber: value.DispatchNumber
            //});
        }
    }
    subs_duplicate: Subscription;
    duplicate() {
        CommonFunctions.unsubscribe(this.subs_duplicate);
        this.subs_duplicate = this.svc_data.duplicateDispatch(this.id).subscribe((info: BaseMessageInfo) => {
            if (!info.saveError) {
                //this.saveSuccess("");
                let msg: string = "The dispatch was duplicated successfully - New #: " + info.dcValues["newDispatchNumber"] + ". Would you like to navigate to the new dispatch?";
                let title: string = "Duplicate Successful";
                this.cnfShow(msg, CRUDActions.None, info.dcValues, title, "DUPLICATE_DISP", false);
            }
            else {
                this.saveError(info.message);
            }
        });
    }
    confirmCustom(data: ConfirmOutput) {
        if (data.dialogResult === CPDialogResult.ok && data.code === "DUPLICATE_DISP") {
            let id = data.data["newDispatchId"];
            this.getDataFromId(id);
        }
    }
    doAction(param: CommonParam) {
        let action: string = param.getParam("ACTION");
        let code: string = param.getParam("CODE");
        let id: any = param.getParam("ID");
        switch (action.toUpperCase()) {
            case "GETPAGEDATA":
                this.pageData.getData(id, code);
                break;
        }
    }
    invoicePickerClosed(e: any) {
        this.closeEvent.emit(null);
    }
    //protected setCommon(dqoiItem: DQOIItem) {
    //        if (dqoiItem.hasDispatchId) {
    //            this.common.addParam("DispatchId", dqoiItem.dispatchId);
    //            this.common.addParam("DispatchNumber", dqoiItem.dispatchNumber);
    //            this.common.addParam("DispatchAccountClassId", dqoiItem.dispatchAccountClassId);
    //        }
    //}

}

